import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ModFilters } from '../../../components/ModFilters';
import { StoreDateTime } from '../../../components/StoreDateTime';
import { PlanogramComplianceResponse } from '../../../types';

interface ImageAuditHeaderProps {
  storeName: string | null;
  deviceName: string | null;
  imageId: string | null;
  createdAt: string | null;
  storeTimeZone?: string;
  allTagNames: string[];
  enabledMods: Set<string>;
  toggleMod: (tagName: string) => void;
  planogramComplianceData?: PlanogramComplianceResponse | null;
  gtSampleId?: string | null;
}

export const ImageAuditHeader: React.FC<ImageAuditHeaderProps> = ({
  storeName,
  deviceName,
  imageId,
  createdAt,
  storeTimeZone,
  allTagNames,
  enabledMods,
  toggleMod,
  planogramComplianceData,
  gtSampleId,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="bg-white shadow-sm border-b rounded-lg p-4">
      <div className="space-y-3">
        <div className="flex justify-between">
          <div>
            <h1 className="text-xl font-bold mb-3">Image Detail</h1>
            <div className="text-gray-600 text-sm">
              {storeName && `Store: ${storeName}`}
              {imageId && ` • Image ID: ${imageId}`}
              {createdAt && (
                <>
                  {' • Created at: '}
                  <StoreDateTime value={createdAt} storeTimeZone={storeTimeZone} />
                </>
              )}
            </div>
          </div>
          <div className="flex items-start gap-2">
            {storeName && deviceName && imageId && (
              <a
                href={`/stores/${storeName}/${deviceName}?image_id=${imageId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-md flex items-center gap-1"
              >
                Image
                <OpenInNewIcon fontSize="small" />
              </a>
            )}
            {gtSampleId && (
              <a
                href={`/eval/gt-samples/${gtSampleId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-md flex items-center gap-1"
              >
                Eval Sample
                <OpenInNewIcon fontSize="small" />
              </a>
            )}
            <button
              onClick={handleBack}
              className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-md"
            >
              Back
            </button>
          </div>
        </div>
        <div className="flex gap-4">
          <ModFilters
            allTagNames={allTagNames}
            enabledMods={enabledMods}
            toggleMod={toggleMod}
            planogramComplianceData={planogramComplianceData}
          />
        </div>
      </div>
    </div>
  );
};
